import insertIcon from './insertIcon'
import crtLogo from '../images/icon-logo-ct.svg'

import iconSearch from '../images/header-search-ic.png'
import iconLogoTv from '../images/logo-tv.png'
import iconCalendarArrow from '../images/calendar-arr.png'
import iconPrint from '../images/btn-texture.png'

export default () => {
	insertIcon('#searchIcon', iconSearch)
	insertIcon('#mobileSearchIcon', iconSearch)
	insertIcon('#footerDtr', crtLogo)
	// insertIcon('#iconLogoTv', iconLogoTv, true)

	if (document.querySelector('#calendarSlider')) {
		insertIcon('.arr-l', iconCalendarArrow)
		insertIcon('.arr-r', iconCalendarArrow)
	}

	if (document.querySelector('.iconPrint')) {
		insertIcon('.iconPrint', iconPrint)
	}

  	document.querySelector('.dtr .dtr__icon').innerHTML = crtLogo
}
